// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Entity model belongsTo relations 1`] = `
Array [
  "Entity",
  "Location",
]
`;
